<template>
  <!-- 模板部分保持不变，主要修改v-for的key绑定 -->
  <div class="layout">
    <div class="top">
      <div class="box">
        <div class="topTitle">About this property</div>
        <div class="introduce">
          Comfortable Accommodations: StarLand Stays in Auckland offers family rooms with air-conditioning,
          kitchenettes, private bathrooms, and free WiFi. Each room includes a dining area, work desk, and TV.
          Convenient Facilities: Guests benefit from private and express check-in and check-out, paid shuttle service,
          housekeeping, laundry, and free on-site parking. Additional amenities include a sofa bed and ground-floor unit.
          Prime Location: Located 19 km from Auckland Airport, the motel is near Mount Smart Stadium (4 km),
          Ellerslie Events Centre and Racecourse (5 km), and Auckland War Memorial Museum (11 km).
        </div>
        <Button type="primary" @click="toLink">Book now</Button>
      </div>
    </div>

    <div
      v-for="(room) in rooms"
      :key="room.id"
      :class="['content', { second: room.theme === 'dark' }]"
    >
      <h2 class="title" :data-aos="room.theme === 'dark' ? 'fade-left' : 'fade-right'">{{ room.title }}</h2>
      <p class="subtitle" data-aos="fade-up">{{ room.subtitle }}</p>

      <div class="box">
        <div class="box-l">
          <el-carousel indicator-position="none" :interval="4000" type="card" arrow="never">
            <el-carousel-item v-for="(img) in room.images" :key="img.id"> <!-- 使用img.id作为key -->
              <el-image :src="img.src" fit="cover" 
              :preview-src-list="room.images.map(img => img.src)" 
             ></el-image>
            </el-carousel-item>
          </el-carousel>
           <Button type="primary" @click="toLink"> <div class="booknow">
              <img src="../../assets/img/booknow.png" alt="book icon" />
            </div>
            <div class="button-span">
              Book Now
            </div></Button>
        </div>

        <div class="box-r">
          <div class="box-r-box" v-for="(section, sIndex) in features" :key="sIndex" data-aos="fade-up">
            <div class="box-r-desc">{{ section.title }}</div>
            <ul>
              <li v-for="(item, iIndex) in section.content" :key="iIndex">
                <div class="boxIcon">
                  <img src="../../assets/img/lodginIcon1.png" alt="icon" />
                </div>
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <ul>
        <li v-for="(item, index) in footer" :key="index">
          <div class="footerIcon">
            <img :src="item.src" :alt="item.title" />
          </div>
          {{ item.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "Lodging",
  data() {
    return {
      footer: [
        { title: "Private kitchen", src: require("../../assets/img/footer1.png") },
        { title: "Private Bathroom", src: require("../../assets/img/footer2.png") },
        { title: "Air-conditioning", src: require("../../assets/img/footer3.png") },
        { title: "Flat panel TV", src: require("../../assets/img/footer4.png") },
        { title: "Free WiFi", src: require("../../assets/img/footer5.png") },
        { title: "Parking Lot", src: require("../../assets/img/footer6.png") },
      ],
      rooms: [
        {
          id: "room-001",
          title: "Deluxe Queen Studio",
          subtitle: "The studio features air conditioning, a dining area, as well as a private bathroom boasting a shower and a hairdryer. The well-fitted kitchen has a stovetop, a refrigerator, kitchenware and a microwave. The studio offers a wardrobe, an electric kettle, a carpeted floor, as well as a flat-screen TV. The unit has 1 bed.",
          theme: "light",
          images: [
            { id: "img-001-01", src: require("../../assets/img/DeluxeQueenStudio1.jpg") }, // 添加id
            { id: "img-001-02", src: require("../../assets/img/DeluxeQueenStudio2.jpg") }, // 添加id
            { id: "img-001-03", src: require("../../assets/img/DeluxeQueenStudio3.jpg") }, // 添加id
            { id: "img-001-04", src: require("../../assets/img/DeluxeQueenStudio4.jpg") }, // 添加id
          ],
        },
        {
          id: "room-002",
          title: "Deluxe Family Room",
          subtitle: "The family room provides air conditioning, a dining area, as well as a private bathroom featuring a shower and a hairdryer. Guests can make meals in the kitchen that is equipped with a stovetop, a refrigerator, kitchenware and a microwave. The family room features a flat-screen TV, a wardrobe, an electric kettle, as well as a carpeted floor. The unit offers 2 beds.",
          theme: "dark",
          images: [
            { id: "img-002-01", src: require("../../assets/img/DeluxeFamilyRoom1.jpg") }, // 添加id
            { id: "img-002-02", src: require("../../assets/img/DeluxeFamilyRoom2.jpg") }, // 添加id
            { id: "img-002-03", src: require("../../assets/img/DeluxeFamilyRoom3.jpg") }, // 添加id
            { id: "img-002-04", src: require("../../assets/img/DeluxeFamilyRoom4.jpg") }, // 添加id
          ],
        },
        {
          id: "room-003",
          title: "Deluxe Double Room",
          subtitle: "The double room offers air conditioning, a dining area, as well as a private bathroom featuring a shower and a hairdryer. Guests can make meals in the kitchen that comes with a stovetop, a refrigerator, kitchenware and a microwave. The double room provides a flat-screen TV, a wardrobe, an electric kettle and a carpeted floor. The unit offers 1 bed.",
          theme: "light",
          images: [
            { id: "img-003-01", src: require("../../assets/img/DeluxeDoubleRoom1.jpg") }, // 添加id
            { id: "img-003-02", src: require("../../assets/img/DeluxeDoubleRoom3.jpg") }, // 添加id
            { id: "img-003-03", src: require("../../assets/img/DeluxeDoubleRoom4.jpg") }, // 添加id
          ],
        },
      ],
      features: [
        {
          title: "Private kitchen provides:",
          content: ["Refrigerator", "Microwave Oven", "Kitchenware", "Electric Kettle", "Stove", "Toaster", "Dining Table"],
        },
        {
          title: "Private bathroom provides:",
          content: ["Free toiletries", "Shower", "Toilet", "Towel", "Hair Dryer", "Additional towels/bed sheets", "Toilet paper"],
        },
        {
          title: "Facilities and Services:",
          content: [
            "Air-conditioning", "Bed linens", "Desk", "Television", "Fridge", "Iron", "Microwave",
            "Flat panel TV", "Kitchenware", "Carpeted floor", "Wardrobe", "Toaster",
            "Dining Area", "Carbon Monoxide Detector",
          ],
        },
      ],
    };
  },
  methods: {
    toLink() {
      window.open("https://hotels.cloudbeds.com/reservation/Uag5xF", "_blank");
    },
  },
  mounted() {
    const img = new Image();
    img.src = require("../../assets/img/lodgingBackImg.png");
    document.querySelector(".top").style.backgroundImage = `url(${img.src})`;
    AOS.init({ duration: 800, once: true });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/mainStyle.scss";
@import "accommodation.scss";
</style>